// extracted by mini-css-extract-plugin
export default {"mailContainer":"MailPage_mailContainer__Sk98l"};